import React from 'react';
import Container from './Container';
import Presenter from './Presenter';

const AnswerOptionEditor = ({...props})=><Container {...props} 
	render={(containerProps,other)=><Presenter {...containerProps} {...other} />}
/>;

export default AnswerOptionEditor;
